import { getData, postData, putData, deleteData } from './apiService';
import { Scorecard } from '../types/Scorecard'; // Assume the types are defined

// Get all scorecards for a specific host
export const getScorecardsByHostId = async (host_id: string): Promise<Scorecard[]> => {
  try {
    const response = await getData(`/hosts/${host_id}/scorecards`, {});
    return response.data;
  } catch (error) {
    console.error('Failed to fetch scorecards by host ID:', error);
    return [];
  }
};

// Get all scorecards for a specific event
export const getScorecardsByEventId = async (event_id: string): Promise<Scorecard[]> => {
  try {
    const response = await getData(`/events/${event_id}/scorecards`, {});
    return response.data;
  } catch (error) {
    console.error('Failed to fetch scorecards by event ID:', error);
    return [];
  }
};

// Create a new scorecard
export const createScorecard = async (scorecard: Scorecard): Promise<Scorecard | null> => {
  try {
    const response = await postData('/scorecards', scorecard);
    return response.data;
  } catch (error) {
    console.error('Failed to create scorecard:', error);
    return null;
  }
};

// Set a scorecard as default
export const setScorecardAsDefault = async (scorecard_id: string): Promise<Scorecard | null> => {
  try {
    const response = await putData(`/scorecards/${scorecard_id}/default`, {});
    return response.data;
  } catch (error) {
    console.error('Failed to set scorecard as default:', error);
    return null;
  }
};

// Set a scorecard as default
export const updateScorecard = async (scorecard_id: string, scorecard: Scorecard): Promise<Scorecard | null> => {
  try {
    const response = await putData(`/scorecards/${scorecard_id}`, scorecard);
    return response.data;
  } catch (error) {
    console.error('Failed to set scorecard as default:', error);
  }
  return null
};

// Set a scorecard as default
export const removeScorecard = async (scorecard_id: string): Promise<void> => {
  try {
    await deleteData(`/scorecards/${scorecard_id}`, {});
  } catch (error) {
    console.error('Failed to set scorecard as default:', error);
  }
};

// // Get all preset questions associated with a scorecard
// export const getScorecardPresetQuestions = async (scorecard_id: string): Promise<PresetQuestion[]> => {
//   try {
//     const response = await getData(`/scorecards/${scorecard_id}/preset-questions`, {});
//     return response;
//   } catch (error) {
//     console.error('Failed to fetch preset questions for scorecard:', error);
//     return [];
//   }
// };



// // Remove preset questions from a scorecard
// export const removePresetQuestionsFromScorecard = async (
//   scorecard_id: string,
//   question_ids: string[]
// ): Promise<void> => {
//   try {
//     await deleteData(`/scorecards/${scorecard_id}/preset-questions`, { data: { question_ids } });
//   } catch (error) {
//     console.error('Failed to remove preset questions from scorecard:', error);
//   }
// };

// // Get all preset scorecard questions
// export const getPresetScorecardQuestions = async (): Promise<PresetQuestion[]> => {
//   try {
//     const response = await getData('/preset-scorecard-questions', {});
//     return response;
//   } catch (error) {
//     console.error('Failed to fetch preset scorecard questions:', error);
//     return [];
//   }
// };
